var React = require('react');

function ProctoringWhite (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m55 9-40 9.6v34.8c0 24.7 26.2 36.3 40 48.6 13.8-12.3 40-23.9 40-48.6V18.6L55 9z","fill":"none","stroke":"#ffffff","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-545454","key":0}),React.createElement("path",{"d":"M65 41.5H45","fill":"none","stroke":"#ee693f","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-ee693f","key":1})]);
}

ProctoringWhite.defaultProps = {"viewBox":"0 0 110 110","xmlSpace":"preserve","enableBackground":"new 0 0 110 110"};

module.exports = ProctoringWhite;

ProctoringWhite.default = ProctoringWhite;
